module.exports = __webpack_public_path__ + "static/media/shredder.e6aba1f8.svg";